import _ from "lodash";
import { useEffect, useState } from "react";
import { getParsedLocalSuggestionsWithTimeout } from "./Utils";

const localSuggestionsCache = new Map();

const getMemoizationParams = params => {
  const {
    term = "",
    module,
    courses: coursesNode,
    curriculumProgramType,
    availableProjectGroupTypes,
    orgId,
  } = params;
  return {
    hasTerm: !_.isEmpty(term),
    module,
    courses: _.join(_.map(coursesNode, "id")),
    curriculumProgramType: _.join(curriculumProgramType),
    availableProjectGroupTypes: _.join(
      _.map(availableProjectGroupTypes, "type")
    ),
    orgId,
  };
};

const useLocalSuggestions = ({
  t,
  module,
  searchText,
  orgId,
  courses,
  curriculumProgramType,
  availableProjectGroupTypes,
}) => {
  const [localSuggestions, setLocalSuggestions] = useState([]);
  const [isLocalSuggestionsLoading, setIsLocalSuggestionsLoading] = useState(
    true
  );

  useEffect(() => {
    const params = {
      term: searchText,
      module,
      courses,
      orgId,
      curriculumProgramType,
      availableProjectGroupTypes,
      shouldIncludeOnlyAdminModules: true,
    };
    getLocalSuggestions(params);
  }, [
    Boolean(searchText),
    module,
    _.join(_.map(courses, "id")),
    _.join(_.map(availableProjectGroupTypes, "type")),
  ]);

  const getLocalSuggestions = params => {
    const memoizationParams = getMemoizationParams(params);
    const paramsKey = JSON.stringify(memoizationParams);

    if (localSuggestionsCache.has(paramsKey)) {
      onLocalSuggestionComputationComplete({
        data: localSuggestionsCache.get(paramsKey),
        paramsKey,
      });
      return;
    }
    setIsLocalSuggestionsLoading(true);
    getParsedLocalSuggestionsWithTimeout({
      t,
      onComplete: data =>
        onLocalSuggestionComputationComplete({ data, paramsKey }),
      ...params,
    });
  };

  const onLocalSuggestionComputationComplete = ({ data, paramsKey }) => {
    setLocalSuggestions(data);
    setIsLocalSuggestionsLoading(false);
    localSuggestionsCache.set(paramsKey, data);
  };

  return {
    localSuggestions,
    isLoading: isLocalSuggestionsLoading,
  };
};

export default useLocalSuggestions;
